// extracted by mini-css-extract-plugin
export var compactFilters = "_gs-4";
export var detailImage = "_gs-1";
export var dropdownContainer = "_gs-2";
export var imageContainer = "_gs-0";
export var selectedCard = "_gs-3";